import Navbar from "./Navbar";
import Hero from "./Hero";
import ExamCategories from "./ExamCategories";
import Features from "./Features";
import Pricing from "./Pricing";
import HowItWorks from "./HowItWorks";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";
import FinalCTA from "./FinalCTA";
import LiveNotifier from "./LiveNotifier";
import ChatWidget from "./ChatWidget";
import ExitIntentPopup from "./ExitIntentPopup";
import StickyMobileBar from "./StickyMobileBar";
import MeditationPromoBar from "./MeditationPromoBar";

export default function MindToMasterLanding() {
  return (
    <div className="min-h-screen bg-[#070b14] text-white antialiased">
      <Navbar />
      <main>
        <Hero />
        <ExamCategories />
        <Features />
        <Pricing />
        <HowItWorks />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <LiveNotifier />
      <ChatWidget />
      <StickyMobileBar />
      <ExitIntentPopup />
      <MeditationPromoBar />
    </div>
  );
}
